import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router'
import { QuickViewSelector } from '../../components/menus/quick-view-selector'
import { useGetRepository } from '../../utils/api-client/api-hooks.ts'
import { useRepositoryDetailsPageParams, useSelectedTool } from './repository-details-page.tsx'
import { createScanQuickViewSelectItem, SCAN_QUICK_VIEW_IDS, type ScanQuickViewId } from './scan-quick-view-config'
import { parseScanView, patchSearchParams, ScansList, useScanQuickViewCounts } from './scans-list.tsx'

export const ScansTab: React.FC = () => {
  return (
    <div>
      <ScanTabHeader />
      <ScansTabList />
    </div>
  )
}

const ScansTabList: React.FC = () => {
  const { repositoryId } = useRepositoryDetailsPageParams()
  const { selectedTool } = useSelectedTool()
  const { data: repository } = useGetRepository({ repositoryId })
  return <ScansList repositoryIds={[repositoryId]} tools={selectedTool ? [selectedTool] : []} repository={repository} />
}

const ScanTabHeader: React.FC = () => {
  const { repositoryId } = useRepositoryDetailsPageParams()
  const { selectedTool } = useSelectedTool()
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedQuickView = parseScanView(searchParams.get('scan-view'))
  const scanQuickViewCounts = useScanQuickViewCounts({
    repositoryIds: [repositoryId],
    tools: selectedTool ? [selectedTool] : [],
  })

  const quickViews = useMemo(
    () => SCAN_QUICK_VIEW_IDS.map(id => createScanQuickViewSelectItem(id, scanQuickViewCounts[id])),
    [scanQuickViewCounts]
  )

  const onSelectedQuickViewChange = useCallback(
    (view: ScanQuickViewId) => {
      setSearchParams(prev => patchSearchParams(prev, { 'scan-view': view, 'page-number': null }))
    },
    [setSearchParams]
  )

  return (
    <QuickViewSelector
      quickViews={quickViews}
      selectedQuickView={selectedQuickView}
      onSelectedQuickViewChange={onSelectedQuickViewChange}
    />
  )
}
